<div class="container-fluid">
  <div class="row pl--1rem8  d-flex align-items-center">
    <div class="col-md-10 step-title">
      <h5>Build New Visa</h5>

    </div>
  </div>
  <div class="vd-container">
    <form [formGroup]="visaCreateForm" class="w-100">
      <div class="p-fluid p-formgrid p-grid pt-2">
        <div class="p-col-6">
          <label for="visaName" class="label-cls required">Enter Visa Name</label>
          <input type="text" pInputText class="" name="visaName" formControlName="visaName">

          <span class="invalid-message"
            *ngIf="visaCreateForm.get('visaName').touched && visaCreateForm.get('visaName').errors?.required">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
      </div>
      <p-divider type="dashed"></p-divider>
      <div class="p-fluid p-formgrid p-grid pt-2">
        <div class="p-col-3" *ngIf="listCountry.length > 0">
          <label for="countryCode" class="label-cls required">Country</label>
          <p-dropdown inputId="countryCode" [options]="listCountry" (onChange)="handleCountryChange()"
            formControlName="countryCode" name="countryCode" optionLabel="countryName" optionValue="countryCode"
            placeholder="Select a Country">
          </p-dropdown>


          <span class="invalid-message"
            *ngIf="visaCreateForm.get('countryCode').touched && visaCreateForm.get('countryCode').errors?.required">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>

        <div class="p-col-3">
          <label for="language" class="label-cls required">Language</label>
          <p-dropdown inputId="language" [options]="languageArr" formControlName="language" name="language"
            optionLabel="name" optionValue="code" placeholder="Select a language" (onChange)="handleChange()">
          </p-dropdown>


          <span class="invalid-message"
            *ngIf="visaCreateForm.get('language').touched && visaCreateForm.get('language').errors?.required">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
      </div>
      <p-divider type="dashed" *ngIf="formTypeArr.length > 0"></p-divider>
      <div class="p-fluid p-formgrid p-grid pt-2 mr-4 p-col-10">
        <div class="p-col-3 pr-4" *ngIf="formTypeArr.length > 0">
          <label for="language" class="label-cls required">Form Type</label>
          <p-listbox listStyleClass="selectBoxStyle" [options]="formTypeArr" optionLabel="name" optionValue="code"
            formControlName="formType" (onChange)="handleChange()"></p-listbox>
          <span class="invalid-message"
            *ngIf="visaCreateForm.get('formType').touched && visaCreateForm.get('formType').errors?.required">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
        <div class="p-col-3 pr-4" *ngIf="!showImmigrantSection && visaTypeArr.length > 0">
          <label for="language" class="label-cls required">Visa Type</label>
          <p-listbox listStyleClass="selectBoxStyle" [options]="visaTypeArr" optionLabel="name" optionValue="code"
            formControlName="visaType" (onChange)="handleVisaTyepeChange()"></p-listbox>
        </div>
        <div class="p-col-3 pr-4" *ngIf="!showImmigrantSection && petitionTypeArr.length > 0">
          <label for="language" class="label-cls required">Petition Type</label>
          <p-listbox listStyleClass="selectBoxStyle" [options]="petitionTypeArr" optionLabel="name" optionValue="code"
            formControlName="petitionType" (onChange)="handlePetitionTypeChange()"></p-listbox>
        </div>
        <div class="p-col-3 pr-4" *ngIf="showImmigrantSection && visaTypeArr.length > 0">
          <label for="language" class="label-cls required">Immigration Category</label>
          <p-listbox listStyleClass="selectBoxStyle" [options]="visaTypeArr" optionLabel="name" optionValue="code"
            formControlName="immCategoryCode" (onChange)="handleVisaTyepeChange()"></p-listbox>
        </div>
        <div class="p-col-3 pr-4" *ngIf="showImmigrantSection && petitionTypeArr.length > 0">
          <label for="language" class="label-cls required">Immigration Classification</label>
          <p-listbox listStyleClass="selectBoxStyle" [options]="petitionTypeArr" optionLabel="name" optionValue="code"
            formControlName="immClassificationCode" (onChange)="handlePetitionTypeChange()"></p-listbox>
        </div>
        <div class="p-col-3 pr-4" *ngIf="showSubTaskTypeSection">
          <label for="language" class="label-cls required">Sub-Task Type</label>
          <p-listbox listStyleClass="selectBoxStyle" [options]="subTaskTypeArr" optionLabel="name" optionValue="code"
            formControlName="subTaskType" (onChange)="handleSubTaskChange()"></p-listbox>
        </div>

      </div>
      <p-divider type="dashed" *ngIf="feeData.length > 0"></p-divider>

      <div class="row my-2" *ngIf="feeData.length > 0">
        <div class="col-8">
          <h6><b>Standard Fee Structure</b></h6>
        </div>
        <div class="col resetButtonDiv">
          <button type="button" [disabled]="publishedOn && !isRepublish && !isEditVisa || isView" class="btn vdResetBtn"
            (click)="handleResetFee()">Reset</button>
          <!-- <button type="button" pButton label="Reset" (click)="handleResetFee()"
          class="p-button-outlined"></button> -->
        </div>
      </div>

      <div class="col-10">
        <div class="row" *ngIf="feeData.length > 0">
          <p-table [value]="feeData" styleClass="vdFeeTable" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th scope="col" class="col-3">Fee Type</th>
                <th scope="col">Amount</th>
                <th scope="col" colspan="2" class="col-3"><span>Employee Count</span></th>
                <th scope="col">Action</th>

              </tr>
              <tr>
                <th scope="col" colspan="2"></th>
                <th scope="col">Min</th>
                <th scope="col">Max</th>
                <th scope="col"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-ri="rowIndex">
              <tr>
                <td>{{item?.feeType?.name}}</td>
                <td>{{item?.applicableFee | currency: 'USD'}}</td>
                <td>{{item?.minEmpCount ? item?.minEmpCount : 0 }}</td>
                <td>{{item?.maxEmpCount ? item?.maxEmpCount : '-'}}</td>
                <td> <button pButton pRipple type="button" icon="pi pi-pencil" title="Edit" pTooltip="Edit"
                    [disabled]="publishedOn && !isDuplicate && !isRepublish && !isEditVisa || isView" class="p-button-rounded p-button-text"
                    (click)="editFeeType(ri,item)"></button>
                  <button pButton pRipple type="button" icon="pi pi-trash" title="Delete" pTooltip="Delete"
                    [disabled]="publishedOn && !isDuplicate && !isRepublish && !isEditVisa || isView" class="p-button-rounded p-button-text"
                    (click)="deleteFeeType(ri,feeData)"></button>
                </td>

              </tr>
            </ng-template>
          </p-table>

          <div class="row">
            <div class="add-task-btn pt-2">
              <!-- <a class="add-btn task-btn" href="javascript:void(0);" role="button" (click)="addNewFeeType()">+ Add New
                Fee Type</a> -->
              <button type="button" [disabled]="publishedOn && !isDuplicate && !isRepublish && !isEditVisa || isView"  class="btn vdResetBtn"
                (click)="addNewFeeType()"> Add New Fee Type </button>
            </div>
          </div>

        </div>

      </div>

      <div class="row mt-3" *ngIf="newlyAddedFeeTypeArr.length > 0">
        <div class="col-8">
          <h6><b>Newly Added Fee Details</b></h6>
        </div>

      </div>

      <div class="col-10">
        <div class="row" *ngIf="newlyAddedFeeTypeArr.length > 0">
          <p-table [value]="newlyAddedFeeTypeArr" styleClass="vdFeeTable" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th scope="col">Fee Type</th>
                <th scope="col">Amount</th>
                <th scope="col" colspan="2" class="col-3"><span>Employee Count</span></th>
                <th scope="col">Action</th>

              </tr>
              <tr>
                <th scope="col" colspan="2"></th>
                <th scope="col">Min</th>
                <th scope="col">Max</th>
                <th scope="col"></th>
              </tr>

            </ng-template>
            <ng-template pTemplate="body" let-item let-ri="rowIndex">
              <tr>
                <td>{{item?.feeType?.name}}</td>
                <td>{{item?.applicableFee | currency: 'USD'}}</td>
                <td>{{item?.minEmpCount ? item?.minEmpCount : 0 }}</td>
                <td>{{item?.maxEmpCount ? item?.maxEmpCount : '-'}}</td>

                <td> <button pButton pRipple type="button" icon="pi pi-pencil" title="Edit" pTooltip="Edit"
                    [disabled]="publishedOn && !isRepublish || isView" class="p-button-rounded p-button-text"
                    (click)="editFeeType(ri,item)"></button>
                  <button pButton pRipple type="button" icon="pi pi-trash" title="Delete" pTooltip="Delete"
                    [disabled]="publishedOn && !isRepublish || isView" class="p-button-rounded p-button-text"
                    (click)="deleteFeeType(ri,newlyAddedFeeTypeArr)"></button>
                </td>

              </tr>
            </ng-template>
          </p-table>



        </div>

      </div>
      <p-divider type="dashed"></p-divider>
      <div class="p-fluid p-formgrid p-grid py-2">
        <div class="p-col-7 pl-0 ml-0" formArrayName="initiateTask">
          <p class="label-cls pl-3">Who can initiate the Task</p>
          <div>
            <div class="row mt-2" style="display: block;">
              <ng-container *ngFor="let x of initiateTaskPermissionArr;index as i">

                <div class="col-2" style="display: inline-block;">
                  <p-checkbox [label]="x.name" [formControlName]="i" binary="true" [disabled]="x.disabled"></p-checkbox>
                </div>

              </ng-container>
            </div>

          </div>
        </div>
      </div>
      <p-divider type="dashed"></p-divider>
      <div class="p-fluid p-formgrid p-grid py-2" *ngIf="serviceCenterList?.length > 0">
        <div class="p-col-7 pl-0 ml-0" formArrayName="serviceCenterJson">
          <p class="label-cls required pl-3">Select Service Center</p>
          <div>
            <div class="row mt-2" style="display: block;">
              <ng-container *ngFor="let x of serviceCenterList;index as i">

                <div class="col-4" style="display: inline-block;">
                  <p-checkbox [label]="x.centerName" [formControlName]="i" binary="true"
                    [disabled]="(publishedOn && !isDuplicate && !isRepublish) ? true : false"></p-checkbox>
                </div>


              </ng-container>
            </div>

          </div>
        </div>

      </div>
      <div class="invalid-message"
        *ngIf="visaCreateForm.get('serviceCenterJson').touched && !this.visaCreateForm.value['serviceCenterJson'].includes(true)">
        Please select atleast one service center
      </div>
      <p-divider type="dashed"></p-divider>
      <div class="buttonContainer my-2">
        <div> <button type="button" class="btn vdCancelBtn mr-3" (click)="hadleCancel()">CANCEL</button></div>
        <div> <button type="submit" class="btn vdCreateBtn mr-3" *ngIf="(!publishedOn || isDuplicate || isRepublish || isEditVisa) && !isView"
            (click)="createNewVisa()"
            [disabled]="visaCreateForm.invalid">SAVE</button>
        </div>
        <!-- <div> <button type="submit" class="btn vdCreateBtn mr-3" *ngIf="!publishedOn" (click)="createNewVisa()">SAVE</button></div> -->
        <div> <button class="btn vdCreateBtn mr-3" *ngIf="publishedOn && !isDuplicate && !isRepublish && !isEditVisa || isView" (click)="onNext()">NEXT</button>
        </div>
      </div>
    </form>
  </div>
</div>
<p-dialog [contentStyle]="{'overflow': 'visible'}" [(visible)]="displayAddFeeTypePanel" [modal]="true"
  [responsive]="true" [style]="{width: '600px', minWidth: '200px'}" [minY]="70" [maximizable]="false"
  [baseZIndex]="50000">
  <ng-template pTemplate="header">
    <div>
      <div class="row">
        <div class="col-12 p-3">
          <h6>Add New Fee Type</h6>
        </div>
      </div>

    </div>
  </ng-template>

  <div class="row form-group">
    <div class="col-6 pl-0">
      <label class="label-cls required">Enter Fee Type</label>
      <input name="name" type="text" pInputText [(ngModel)]="newFeeType.name" required [disabled]="newFeeType?.id" />
    </div>
    <div class="col-6 pl-4">
      <label class="label-cls required">Enter Fee Amount</label>
      <!-- <input name="feeAmount" type="text" pInputText [(ngModel)]="newFeeType.feeAmount" required /> -->
      <p-inputNumber [(ngModel)]="newFeeType.feeAmount" mode="currency" currency="USD" locale="en-US"></p-inputNumber>
    </div>
  </div>
  <div>
    <label class="label-cls my-3">Employment Count</label>

    <div class="row form-group">

      <div class="pl-0 pr-2">
        <label class="label-cls">Min</label>
        <p-inputNumber [(ngModel)]="newFeeType.minEmpCount" class="pl-3 col-2"></p-inputNumber>
      </div>
      <div class="pl-0 pr-2">
        <label class="label-cls">Max</label>
        <p-inputNumber [(ngModel)]="newFeeType.maxEmpCount" class="pl-3 col-2"></p-inputNumber>
      </div>
    </div>
  </div>


  <p-footer>
    <div class="buttonContainer my-2">
      <div *ngIf="!showUpdateButton"> <button type="submit" class="btn vdCreateBtn mr-3" (click)="saveNewFeeType('ADD')"
          [disabled]="newFeeType.name =='' && !newFeeType.feeAmount">ADD</button></div>
      <div *ngIf="showUpdateButton"> <button type="button" class="btn vdCreateBtn mr-3"
          (click)="saveNewFeeType('UPDATE')" [disabled]="newFeeType.name =='' && !newFeeType.feeAmount">UPDATE</button>
      </div>
      <div> <button type="button" class="btn vdCancelBtn mr-3" (click)="feeTypeCancel()">CANCEL</button></div>

    </div>
  </p-footer>
</p-dialog>
<p-confirmDialog header="Delete" key="confirmDelete"></p-confirmDialog>
<p-confirmDialog header="Are you sure" key="confirmVersioning"></p-confirmDialog>